import { HttpClient } from '@angular/common/http';
import { Injector } from '@angular/core';
import { LemsarApiClient } from '@lemsar/api/client';
import { environment } from '../../../../environments/environment';

export function apiServiceFactory(http: HttpClient, injector: Injector): LemsarApiClient {
    return new LemsarApiClient(environment.lemsarApiEndpoint, http, injector);
}



// WEBPACK FOOTER //
// ./src/lemsar/api/factories/api-client.factory.ts